import { useState } from "react";
import { Button, Dialog, toast } from "../ui";
import { discussionsApi, errMessage, REPORT_REASONS } from "./api";

/** Report a message to moderators (spec §7). Snapshots the body server-side. */
export default function ReportDialog({ open, onOpenChange, messageId }) {
  const [reason, setReason] = useState("SPAM");
  const [note, setNote] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const reset = () => {
    setReason("SPAM");
    setNote("");
  };

  const close = (next) => {
    if (!next) reset();
    onOpenChange(next);
  };

  const submit = async () => {
    if (submitting || !messageId) return;
    setSubmitting(true);
    try {
      const res = await discussionsApi.reportMessage(messageId, {
        reason,
        note: note.trim() || undefined,
      });
      toast.success(
        res.created
          ? "Reported — moderators have been notified."
          : "You have already reported this message."
      );
      reset();
      onOpenChange(false);
    } catch (e) {
      toast.error(errMessage(e));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog
      open={open}
      onOpenChange={close}
      title="Report this message"
      className="vdsc-report"
      footer={
        <>
          <Button variant="secondary" onClick={() => close(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={submit} loading={submitting}>
            Report
          </Button>
        </>
      }
    >
      <div className="vdsc-field">
        <label className="vdsc-label" htmlFor="vdsc-report-reason">
          Reason
        </label>
        <select
          id="vdsc-report-reason"
          className="vdsc-select"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        >
          {REPORT_REASONS.map((r) => (
            <option key={r.value} value={r.value}>
              {r.label}
            </option>
          ))}
        </select>
      </div>
      <div className="vdsc-field">
        <label className="vdsc-label" htmlFor="vdsc-report-note">
          Add context (optional)
        </label>
        <textarea
          id="vdsc-report-note"
          className="vdsc-textarea"
          rows={3}
          maxLength={2000}
          placeholder="Anything the moderators should know."
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
      </div>
    </Dialog>
  );
}
